import Carousel from 'CoreComponents/carousel';

if (document.querySelector('.carousel')) {
  new Carousel(document.querySelector('.carousel'), {});
}
